import api from "@/services/api";

export default {
  getList(params) {
    return api.get('/report/asset-number', { params });
  },
  exportExcel(params) {
    return api.get('/report/asset-number/export-excel', {
      params,
      responseType: 'blob',
    });
  },
};
